import {Topology} from "@topology/core";
import { MQTT } from './mqtt';

var xyjTopology = Topology;
/**@description: 重写内核方法；
 * 1、实现订阅拼装公司ID；
 * 2、接收到命令处理结果处理
 *@functionName: js
 *@params1: 参数1
 *@params2: 参数2
 *@author: 宋建国
 *@date: 2021-06-10 08:54:26
 *@version: V1.0
*/

xyjTopology.prototype.openMqtt = function(url, options){
    // debugger;
    var _this = this;
    this.closeMqtt();
    if (url || this.data.mqttUrl) {
        /* @description: 订阅主题尾部增加公司ID ,防止多公司下主题重复
         * @author: 宋建国
         * @date: 2021-06-01 15:57:05
         * @version: V1.0
        */
        let mqttTopics = this.data.mqttTopics;
        if(mqttTopics !== "" && mqttTopics !== null && mqttTopics !== undefined){
            let branchId = sessionStorage.getItem("branchId");
            if(branchId !== "" && branchId !== null && branchId !== undefined){
                mqttTopics = mqttTopics + "/" + branchId + "," + window.xyjVue.RunCommandSuccess+branchId;
            }
        }else{
            let branchId = sessionStorage.getItem("branchId");
            if(branchId !== "" && branchId !== null && branchId !== undefined){
                mqttTopics = window.xyjVue.RunCommandSuccess + sessionStorage.getItem("branchId");
            }
        }

        console.info("看板订阅："+mqttTopics);
        let returnTopic = window.xyjVue.RunCommandSuccess + sessionStorage.getItem("branchId");
        returnTopic = returnTopic.toLowerCase();
        this.mqtt = new MQTT(url || this.data.mqttUrl, options || this.data.mqttOptions, mqttTopics, function (topic, message) {
            /* @description:此处修改接收命令执行返回标题判断
             * 原本这一行：_this.doSocket(message.toString(), SocketEventType.Mqtt);
             * @author: 宋建国
             * @date: 2021-06-09 09:50:05
             * @version: V1.0
            */
            if (_this.data.socketEvent !== 1) {
                if(topic.toLowerCase() === returnTopic){
                    window.xyjVue.$TaskQueue.TaskQueueSuccess(message.toString());
                }else{
                    _this.doSocket(message.toString(), 3);
                }
            }
            //*结束 */
            _this.data.socketEvent && _this.dispatch('mqtt', { topic: topic, message: message });
        });
    }
}

function find(idOrTag, pens) {
    var result = [];
    pens.forEach(function (item) {
        if (item.id === idOrTag || item.tags.indexOf(idOrTag) > -1) {
            result.push(item);
        }
        if (item.children) {
            result.push.apply(result, find(idOrTag, item.children));
        }
    });
    return result;
}
/**@description: 重写绘图管理类内核方法，
 * 1.如果两个节点的tab相等，事件不清零则所有节点都会执行第一个节点的方法，此BUG已经处理
 *@functionName: doSocket
 *@params1: 参数1
 *@params2: 参数2
 *@author: 宋建国
 *@date: 2021-06-10 09:14:58
 *@version: V1.0
*/
xyjTopology.prototype.doSocket = function (message, type){
    var _this = this;
    if (type === void 0) { type = 2; }
    try {
        message = JSON.parse(message);
        if (!Array.isArray(message)) {
            message = [message];
        }
        message.forEach(function (item) {
            var actions = [];
            if (item.actions) {
                actions = item.actions;
                delete item.actions;
            }
            var pens = find(item.id || item.tag, _this.data.pens);
            pens.forEach(function (pen) {
                if (pen.id === item.id || (pen.tags && pen.tags.indexOf(item.tag) > -1)) {
                    if(item.data){
                        if(item.data.echarts){
                            /* @description: 图表收到数据后自动刷新
                             * @author: 宋建国
                             * @date: 2021-06-17 22:15:59
                             * @version: V1.0
                            */
                            item["elementRendered"] = false;
                            if(window.xyjVue.$tu.isBlank(pen.data)){
                                pen["data"] = {echarts: {}};
                            }else{
                                if(window.xyjVue.$tu.isBlank(pen.data.echarts)){
                                    pen.data["echarts"] = {};
                                }
                            }
                            window.xyjVue.$tu.ObjectMerge(item.data.echarts,pen.data.echarts);
                        }
                    }
                    pen.fromData(pen, item);
                    pen.doWheres();
                    if (pen.events) {
                        pen.events.forEach(function (event) {
                            if (event.type === type) {
                                actions.push(event);
                            }
                        });
                    }
                    actions && actions.forEach(function (action) {
                        pen.doAction(action);
                    });
                    /* @description: 如果两个节点的tab相等，事件不清零则所有节点都会执行第一个节点的方法，此BUG已经处理
                     * @author: 宋建国
                     * @date: 2021-06-08 11:46:19
                     * @version: V1.0
                    */
                    actions.length = 0;
                }
            });
            _this.willRender();
        });
    }
    catch (error) {
        console.error(error);
    }
}

export { xyjTopology };



// WEBPACK FOOTER //
// ./src/components/topologycomponent/xyjTopology.js